import ScrollTop from 'react-scroll-to-top'

import styles from './ScrollTop.module.scss'

const ScrollTopButton = () => (
  <ScrollTop smooth className={styles['scroll-top']} />
)

export default ScrollTopButton
